import { useEffect } from 'react'

interface KeyboardShortcuts {
  '1'?: () => void
  '2'?: () => void
  '3'?: () => void
  '4'?: () => void
  '5'?: () => void
  'Enter'?: () => void
  'n'?: () => void
  'r'?: () => void
  's'?: () => void
  'ArrowRight'?: () => void
  'ArrowLeft'?: () => void
}

export function useKeyboardShortcuts(shortcuts: KeyboardShortcuts) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Não disparar se estiver em input/textarea
      const target = e.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.contentEditable === 'true'
      ) {
        return
      }

      const key = e.key
      const handler = shortcuts[key as keyof KeyboardShortcuts]

      if (handler) {
        e.preventDefault()
        handler()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [shortcuts])
}
